export var NATIVE_HANDLER_ID="@dicetechnology/doris-handler-native";